const KEYS = {
  videoDeviceId: 'novas.call.videoDeviceId',
  audioDeviceId: 'novas.call.audioDeviceId',
  audioOutputDeviceId: 'novas.call.audioOutputDeviceId',
  alwaysShowPreview: 'novas.call.alwaysShowPreview',
};

export function getSavedVideoDeviceId() {
  try { return localStorage.getItem(KEYS.videoDeviceId) || null; } catch { return null; }
}

export function setSavedVideoDeviceId(deviceId) {
  try {
    if (deviceId) localStorage.setItem(KEYS.videoDeviceId, deviceId);
    else localStorage.removeItem(KEYS.videoDeviceId);
  } catch {}
}

export function getSavedAudioDeviceId() {
  try { return localStorage.getItem(KEYS.audioDeviceId) || null; } catch { return null; }
}

export function setSavedAudioDeviceId(deviceId) {
  try {
    if (deviceId) localStorage.setItem(KEYS.audioDeviceId, deviceId);
    else localStorage.removeItem(KEYS.audioDeviceId);
  } catch {}
}

export function getSavedAudioOutputDeviceId() {
  try { return localStorage.getItem(KEYS.audioOutputDeviceId) || null; } catch { return null; }
}

export function setSavedAudioOutputDeviceId(deviceId) {
  try {
    if (deviceId) localStorage.setItem(KEYS.audioOutputDeviceId, deviceId);
    else localStorage.removeItem(KEYS.audioOutputDeviceId);
  } catch {}
}

export function getAlwaysShowPreview() {
  try { return localStorage.getItem(KEYS.alwaysShowPreview) !== 'false'; } catch { return true; }
}

export function setAlwaysShowPreview(value) {
  try { localStorage.setItem(KEYS.alwaysShowPreview, value ? 'true' : 'false'); } catch {}
}

export function getSavedDeviceSelection() {
  return {
    videoDeviceId: getSavedVideoDeviceId(),
    audioDeviceId: getSavedAudioDeviceId(),
    audioOutputDeviceId: getSavedAudioOutputDeviceId(),
  };
}
